/**
 * 将秒数格式化为 mm:ss 格式
 * @param seconds - 秒数（可以是小数）
 * @returns 格式化字符串，如 "01:23"
 */
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}
